module.exports = __webpack_public_path__ + "assets/img/title-046e2fc3.png";